// MARK:- Grow Zone LP shared zone-refresh helper
// Used by sections/custom-grow-zone-hero.liquid and sections/custom-grow-zone-products.liquid.
// See docs/growing-zone-architecture.md for the SSR-first + reconcile + refresh pattern.

(function () {
  if (window.growZoneLp) return;

  // MARK:- Shared in-flight cache: first caller starts the fetch, others reuse the promise
  const sharedRefresh = () => {
    if (!window.__gzLpRefreshPromise) {
      window.__gzLpRefreshPromise = fetch(window.location.href)
        .then((r) => r.text())
        .then((html) => new DOMParser().parseFromString(html, 'text/html'))
        .catch((err) => { console.warn('[gz-lp] refresh failed:', err); return null; })
        .finally(() => {
          // MARK:- Clear after a tick so a later, separate zone change refetches fresh data
          setTimeout(() => { window.__gzLpRefreshPromise = null; }, 0);
        });
    }
    return window.__gzLpRefreshPromise;
  };

  // MARK:- Bind one surface to the cart:attribute-updated event with its own scope selector.
  // bound[scope] guards against re-binding when the same section's markup is replaced.
  const bound = {};
  const bindSurface = (scope, selector) => {
    if (bound[scope]) return;
    bound[scope] = true;

    const refreshSurface = () => {
      const wrapper = document.querySelector(selector);
      if (!wrapper) return;
      sharedRefresh().then((doc) => {
        if (!doc) return;
        const refreshed = doc.querySelector(selector);
        if (refreshed && wrapper.parentNode) wrapper.replaceWith(refreshed);
      });
    };

    document.addEventListener('cart:attribute-updated', (event) => {
      if (event.detail?.attributeKey !== 'customer_growing_zone') return;
      refreshSurface();
    });
  };

  // MARK:- First-paint localStorage reconcile. Server saw no zone on this surface, but the
  // customer may still have one in localStorage (cart attributes clear on expiry; localStorage
  // persists). syncZoneToCartAttribute writes the cart attribute and dispatches
  // cart:attribute-updated, which triggers bindSurface's refresh listener.
  const reconcileFromLocalStorage = (hasZone) => {
    if (hasZone) return;
    let zone = null;
    let zip = null;
    let state = null;
    try {
      zone = localStorage.getItem('growing_zone');
      zip = localStorage.getItem('growing_zipcode');
      state = localStorage.getItem('growing_state');
    } catch (e) { /* localStorage blocked - stay on no-zone state */ }
    if (!zone) return;
    if (typeof window.syncZoneToCartAttribute === 'function') {
      window.syncZoneToCartAttribute(zone, zip, state);
    }
  };

  // MARK:- Exposed to section scripts via window.growZoneLp
  window.growZoneLp = {
    bindSurface,
    reconcileFromLocalStorage,
  };
})();
